var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{ref:"container",staticClass:"container",style:(_vm.computedStyle)},[_c('div',{staticClass:"content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }